import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import GlobalAutoComplete from '../../../components/GlobalAutoComplete';
import { useSearchParams } from 'react-router-dom';
import { tutorUtilizedTableHeader } from './utils/tutorUtilizedTableHeader';
import Stack from '@mui/material/Stack';
import { useEffect, useMemo, useState } from 'react';
import GlobalSelectFieldWithoutFormik from '../../../components/mui/GlobalSelectFieldWithoutFormik';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getCROUnderProject, getTutorDashboardMainCardsInfo } from '../../../redux/features/CRDslice';
import { dispatchType } from './utils/detailCardDispatchtype';
import { Tab, Tabs } from '@mui/material';
import { getAllProjects } from '../../../redux/features/courseSlice';
import { TUTOR_STATUS, TUTOR_UTILIZATION } from './utils/constaints';

export default function TutorCardDetail() {
  const allProject = useSelector((state) => state.course.projects);
  const [utilize, setUtilize] = useState({ id: -1, value: '' });
  const [status, setStatus] = useState({ id: -1, value: '' });
  const [cro, setCro] = useState(null);
  const [tab, setTab] = useState(0);
  const dispatch = useDispatch();

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const tutorDashboardMainCardInfoTable = useSelector((state) => state.crd.tutorDashboardMainCardInfoTable.data);
  const tutorDashboardMainCardInfoTableLoading = useSelector(
    (state) => state.crd.tutorDashboardMainCardInfoTable.loading,
  );
  const meta = useSelector((state) => state.crd.tutorDashboardMainCardInfoTable?.meta);
  const croUnderProject = useSelector((state) => state.crd.allCroUnderProject);

  // query
  const [query] = useSearchParams();

  const searchParams = useMemo(
    () => ({
      fromDate: query.get('fromDate') ?? null,
      toDate: query.get('toDate') ?? null,
      project_id: query.get('project') ?? null,
      type: query.get('type') ?? '',
      subject_id: query.get('subject') ?? null,
      syllabus_id: query.get('syllabus_id') ?? null,
      gender: query.get('gender') ?? null,
      rating: query.get('rating') ?? null,
      class_id: query.get('class_id') ?? null,
      session_range: query.get('session_range') ?? null,
      from_time: query.get('from_time') ?? null,
      to_time: query.get('to_time') ?? null,
      city: query.get('city') ?? null,
      state: query.get('state') ?? null,
    }),
    [query],
  );

  const [project, setProject] = useState({ id: searchParams?.project_id, value: '' });

  const dispatchParams = useMemo(
    () => ({
      ...searchParams,
      project_id: Number(project?.id) === -1 ? null : project?.id,
      search: tableState?.search,
      page: tableState?.page,
      limit: tableState?.pageSize,
      type: tab || null,
      status: status?.id === -1 ? null : status?.id,
      is_utilized: utilize?.id === -1 ? null : utilize?.id,
      cro_id: cro?.userID || null,
    }),
    [searchParams, project, tableState?.search, tab, tableState?.page, tableState?.pageSize, status, utilize, cro],
  );

  console.log({ pro: Number(project?.id) ? null : project?.id });

  useEffect(() => {
    dispatch(getTutorDashboardMainCardsInfo({ getType: dispatchType?.[searchParams?.type], params: dispatchParams }));
  }, [dispatchParams, dispatch, searchParams]);

  useEffect(() => {
    dispatch(getAllProjects());
  }, [dispatch]);

  useEffect(() => {
    if (searchParams?.type === 'cro_wise') dispatch(getCROUnderProject(project?.id == -1 ? null : project?.id));
  }, [project, dispatch, searchParams?.type]);

  return (
    <GlobalWrapper title={'Tutors Utilized '}>
      <Stack gap={2}>
        <Stack direction={'row'} gap={1} maxWidth={500}>
          <GlobalSelectFieldWithoutFormik
            data={[{ id: -1, name: 'All Project' }, ...allProject]}
            label={'Project'}
            setChange={setProject}
            keys={{ itemId: 'id', itemValue: 'name' }}
            selectedDetails={project}
            sx={{ width: '100%', maxWidth: 250, flex: 1 }}
            disabled={!Boolean(allProject?.length)}
          />
          {searchParams?.type === 'subject_wise' && (
            <>
              <GlobalSelectFieldWithoutFormik
                data={TUTOR_STATUS}
                label={'Status'}
                setChange={setStatus}
                keys={{ itemId: 'id', itemValue: 'label' }}
                selectedDetails={status}
                sx={{ width: '100%', flex: 1 }}
              />
              <GlobalSelectFieldWithoutFormik
                data={TUTOR_UTILIZATION}
                label={'Utilized'}
                setChange={setUtilize}
                keys={{ itemId: 'id', itemValue: 'label' }}
                selectedDetails={utilize}
                sx={{ width: '100%', flex: 1 }}
              />
            </>
          )}
          {searchParams?.type === 'cro_wise' && (
            <GlobalAutoComplete
              data={croUnderProject}
              label="CRO"
              sx={{ width: '100%', flex: 1 }}
              selectValue={cro}
              setSelectValue={setCro}
              keyName={{
                id: 'userID',
                value: 'name',
              }}
            />
          )}
        </Stack>
        {searchParams?.type === 'cro_wise' && (
          <Tabs
            onChange={(_, v) => setTab(v)}
            value={tab}
            sx={{
              bgcolor: '#F3F4F6',
              width: 'fit-content',
              borderRadius: 3,
              p: 1,

              '& .Mui-selected': {
                bgcolor: '#FFFFFF',
                height: 'fit-content',
                borderRadius: 2,
              },
            }}
            indicatorColor="transparent"
          >
            <Tab label="All" value={0} />
            <Tab label="Newly Onboarded" value={1} />
            <Tab label="Old Tutors Utilized" value={2} />
          </Tabs>
        )}

        <GlobalTable
          rows={tutorDashboardMainCardInfoTable}
          headers={tutorUtilizedTableHeader(searchParams.type)}
          loading={tutorDashboardMainCardInfoTableLoading}
          tableState={tableState}
          setTableState={setTableState}
          meta={meta}
          rowUniqueId="sl_no"
        />
      </Stack>
    </GlobalWrapper>
  );
}
